import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { formatWithComma } from '../../../utils/subscription';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';


const topics = [{
    id: 1,
    img: 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427321932.webp',
    text : '⚡Fast-Track:',
    subText : 'Job Prep. Support',
} , {
    id : 2,
    img: 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427321934.webp',
    text : 'Slow Track:',
    subText : 'No Job Support',
}]
const LcpJob = ({razorpayMainHandler , handleOnboardingCompletion}) => {

    const [selectedIndex , setSelectedIndex] = useState(1);
    const maxProduct = useSelector(state => state?.onBoarding?.maxProduct);

  return (
    <div className='w-full'>
        <div className="w-full p-3  rounded-[12px]" style={{backgroundImage : `linear-gradient(
  to bottom,
  rgba(64,106,255,0.15) 0%,
  rgba(25,46,66,0.15) 100%
)`}}>
    <div className='w-full cursor-pointer flex items-center h-[56px] justify-center rounded-[24px] bg-[#12285a] p-[2px]'>
        {topics?.map((topic) => (
            <div key={topic.id} className={`w-full flex items-center text-center justify-center rounded-[24px] ${selectedIndex === 1 ? topic.id === 1 ? 'border-[1px] border-[#2BBD13]' : 'none' : selectedIndex === 2 ? topic.id === 2 ? 'border-[1px]  border-[#EF9121]' : 'none' : 'none'} ${selectedIndex === topic.id && 'h-full bg-[#406AFF]/50'}`} onClick={() => setSelectedIndex(topic.id)}>
                <p className={`text-[12px] flex items-center font-medium ${selectedIndex === topic.id ? 'text-white' : 'text-[#70AEFF]'}`}>{topic?.text} <br /> {topic?.subText} {selectedIndex === 2 && topic.id === 1 && <div className='w-[6px] h-[6px] rounded-full bg-[#2BBD13] ml-2' />} {selectedIndex === 1 && topic.id === 2 && <div className='w-[6px] h-[6px] rounded-full bg-[#EF9121] ml-2' />}</p>
            </div>
        ))}
    </div>
    <div className='w-full mt-6 relative'>
        {topics?.map((topic) => (
            <img 
                key={topic.id}
                alt="" 
                src={topic.img}
                className={`w-full transition-opacity duration-300 ${
                    selectedIndex === topic.id ? 'opacity-100' : 'opacity-0 absolute top-0 left-0'
                }`}
            />
        ))}
    </div>
    
   



        </div>

        <div className='px-[1px] pb-[1px] rounded-lg' style={{backgroundImage : `radial-gradient(closest-side, #8BD845 0%, #C5E2AB 100%)`}} onClick={() =>
            {   
                Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_JOB_PAGE_START_MY_JOB_PREP_NOW_BUTTON_CLICKED);
                Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_PREMIUM_BUTTONS_CLICKED);
                razorpayMainHandler(maxProduct?.id , ()=>{})
            }}>
            <button className="mt-6 flex h-[52px] items-center justify-center gap-2.5 px-[90px] py-3 relative self-stretch w-full bg-[#7fc241] rounded-lg shadow-[0px_0px_10px_#7fc24159] hover:bg-[#7fc241]/90 border-0 cursor-pointer">
            <div className="inline-flex flex-col items-center justify-center gap-1 relative flex-[0_0_auto] mt-[-5.00px] mb-[-5.00px]">
                <span className="relative flex items-center justify-center w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-[#121212] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Start My Job Prep. Now!
                </span>

                <p className="relative flex items-center justify-center w-fit [font-family:'Inter',Helvetica] font-normal text-transparent text-xs text-center tracking-[0] leading-[normal]">
                <span className="font-medium text-[#121212b2]">
                    Early Bird Discount:{" "}
                </span>

                <span className="font-semibold text-[#121212b2]">₹{formatWithComma(maxProduct?.cost)}</span>

                <span className="font-medium text-[#121212b2]">&nbsp;</span>

                <span className="font-medium text-[#e06064] line-through">
                    ₹{formatWithComma(maxProduct?.["pp_original_cost"])}
                </span>
                </p>
            </div>
            </button>
        </div>

        <div className='mt-3 text-white/70 text-[14px] text-center'>OR</div>

        <button className="mt-3 flex h-[52px] items-center justify-center gap-2.5 px-[90px] py-3 relative self-stretch w-full  rounded-lg border-2 border-[#EF9121] cursor-pointer" onClick={() => 
            {
                Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_JOB_PAGE_SEE_MY_JOB_READINESS_SCORE_BUTTON_CLICKED);
                handleOnboardingCompletion()
            }}>
          <div className="inline-flex flex-col items-center justify-center gap-1 relative flex-[0_0_auto] mt-[-5.00px] mb-[-5.00px]">
            <span className="relative flex items-center justify-center w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-[#EF9121] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
            See My Job Readiness Score
            </span>

            <p className="relative flex items-center justify-center w-fit [font-family:'Inter',Helvetica] font-normal text-transparent text-xs text-center tracking-[0] leading-[normal]">
              <span className="font-medium text-white/70 text-[12px]">
              Slow Track - No Job Support*{" "}
              </span>
            </p>
          </div>
        </button>

    </div>
  )
}

export default LcpJob